module.exports = __webpack_public_path__ + "static/media/1029619.cd454319.jpg";